/* eslint-disable react/react-in-jsx-scope */
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  changeSelectCategoryStatus,
  selectCategoryId
} from '../../../category/categorySlice/categorySlice'
import {
  useGetAllSubCategoryByCategoryIdQuery
} from "../../api/subCategoryApiSlice";
import SubCategoryListPresentation from "../../presentation/subcategory.list.presentation/subcategory.list.presentation";
import {
  changeSubCategoryStatus,
  getSubCategoryId,
} from "../../subCategorySlice/subCategorySlice";
import { SubCategory } from "../../types/types";

const SubCategoryListContainer = () => {
  const dispatch = useAppDispatch();
  const categoryId = useAppSelector(selectCategoryId);
  // const allSubCategoires = useAppSelector((state: RootState) =>
  //   selectAllSubCategories(state, categoryId!)(state)
  // );

  const {data:allSubs,isSuccess,} = useGetAllSubCategoryByCategoryIdQuery(categoryId as EntityId)

  const onClickeSubCategoryHandler = (item: Partial<SubCategory>) => {
    dispatch(getSubCategoryId(item._id))
    dispatch(changeSubCategoryStatus(true))
    dispatch(changeSelectCategoryStatus(false))
  }
  return (
    <>
 
    {isSuccess && (<SubCategoryListPresentation
      subcategories={Object.values(allSubs?.entities) as SubCategory[]}
      onSubCategoryClickHandler={onClickeSubCategoryHandler}
    />) }

    </>
  )
}

export default SubCategoryListContainer
